var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    class: {
      resizeBar: true,
      vertical: !_vm.horizontal,
      horizontal: _vm.horizontal
    },
    style: _vm.dynStyle,
    on: { mousedown: _vm.mouseDown, dblclick: _vm.dblClick }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }